//# sourceMappingURL=invite_users.mjs.map
/// <reference types="./invite_users.d.mts" />
import * as $auth from "../../../../altar/altar/auth.mjs";
import * as $when from "../../../../altar/altar/when.mjs";
import * as $connection from "../../../../data_types/data/auth/connection.mjs";
import * as $invitation from "../../../../data_types/data/auth/invitation.mjs";
import * as $role from "../../../../data_types/data/auth/role.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $decrypt from "../../../../data_types/decrypt.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../../ds/ds/components/modal.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $typo from "../../../../ds/ds/components/typography.mjs";
import * as $events from "../../../../ds/ds/events.mjs";
import * as $text from "../../../../ds/ds/typography/text.mjs";
import * as $promise from "../../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dynamic from "../../../../gleam_stdlib/gleam/dynamic.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $set from "../../../../gleam_stdlib/gleam/set.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../../../gleam_time/gleam/time/timestamp.mjs";
import * as $file from "../../../../magellan/magellan/file.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $sh from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $result_ from "../../../../tiamat/gleam/result_.mjs";
import * as $timestamp_ from "../../../../tiamat/gleam/time/timestamp_.mjs";
import * as $function from "../../../../tiamat/tiamat/function.mjs";
import * as $organization_effects from "../../../admin/effects/organization.mjs";
import * as $user_effects from "../../../admin/effects/user.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";
import { parse } from "./invite_users.ffi.mjs";

export class OnConfirm extends $CustomType {
  constructor(connection_id, users) {
    super();
    this.connection_id = connection_id;
    this.users = users;
  }
}
export const OnConfirm$OnConfirm = (connection_id, users) =>
  new OnConfirm(connection_id, users);
export const OnConfirm$isOnConfirm = (value) => value instanceof OnConfirm;
export const OnConfirm$OnConfirm$connection_id = (value) => value.connection_id;
export const OnConfirm$OnConfirm$0 = (value) => value.connection_id;
export const OnConfirm$OnConfirm$users = (value) => value.users;
export const OnConfirm$OnConfirm$1 = (value) => value.users;

class UserRolesProps extends $CustomType {
  constructor(invitation, roles) {
    super();
    this.invitation = invitation;
    this.roles = roles;
  }
}

class UserSelectorProps extends $CustomType {
  constructor(roles, on_end, connection_id) {
    super();
    this.roles = roles;
    this.on_end = on_end;
    this.connection_id = connection_id;
  }
}

class RenderCSVUsersProps extends $CustomType {
  constructor(roles, on_end, users, connection_id) {
    super();
    this.roles = roles;
    this.on_end = on_end;
    this.users = users;
    this.connection_id = connection_id;
  }
}

function user_connection(invitation, connections) {
  let $ = $list.find(
    connections,
    (c) => { return c.id === invitation.connection_id; },
  );
  if ($ instanceof Ok) {
    let connection = $[0];
    let name = $option.unwrap(connection.display_name, connection.name);
    return $label.label(toList([$label.content(name)]));
  } else {
    return $label.label(toList([$label.content("None")]));
  }
}

function date(timestamp, emphasis, expired) {
  let ts = $timestamp_.to_locale_full_date(timestamp);
  return $label.label(
    toList([
      $label.content(ts),
      $label.status(
        $bool.guard(
          !emphasis,
          new $label.Current(),
          () => {
            if (expired) {
              return new $label.Error();
            } else {
              return new $label.Success();
            }
          },
        ),
      ),
    ]),
  );
}

function loading_table() {
  return $table.body(
    (() => {
      let _pipe = $table.row(
        toList([
          $table.cell($skeleton.skeleton(100, 25)),
          $table.cell($skeleton.skeleton(200, 25)),
          $table.cell($skeleton.skeleton(70, 25)),
          $table.cell($skeleton.skeleton(70, 25)),
          $table.cell($skeleton.skeleton(150, 25)),
          $table.cell(
            $l.row(
              toList([$l.gap(4)]),
              toList([]),
              toList([
                $skeleton.skeleton(100, 25),
                $skeleton.skeleton(100, 25),
                $skeleton.skeleton(100, 25),
              ]),
            ),
          ),
        ]),
      );
      return $list.repeat(_pipe, 4);
    })(),
  );
}

function invitations_data(store) {
  return $remote.then$(
    $store.organization_invitations(store),
    (invitations) => {
      return $remote.then$(
        store.roles,
        (roles) => {
          return $remote.then$(
            store.connections,
            (connections) => {
              return new $remote.Loaded([invitations, roles, connections]);
            },
          );
        },
      );
    },
  );
}

function use_organization_invitations(store, dispatch) {
  return ((_capture) => {
    return $redraw.use_effect(_capture, [store.organization]);
  })(
    () => {
      return $when.some_(
        store.organization,
        $function.always(undefined),
        (org_id) => {
          return $remote.load(
            $store.organization_invitations(store),
            () => {
              dispatch($organization_effects.fetch_invitations(org_id));
              return undefined;
            },
          );
        },
      );
    },
  );
}

function user_roles() {
  return $redraw.compose(
    $common.roles(),
    (roles_view) => {
      return $redraw.component_(
        "UserRoles",
        (props) => {
          return roles_view(
            [
              $list.filter_map(
                props.invitation.roles,
                (role) => {
                  let _pipe = $list.find(
                    props.roles,
                    (r) => { return r.id === role; },
                  );
                  return $result.map(_pipe, (r) => { return r.name; });
                },
              ),
            ],
          );
        },
      );
    },
  );
}

function actions() {
  return $redraw.component_(
    "InviteUsersActions",
    (_use0) => {
      let invitation = _use0[0];
      let $ = $redraw.use_state(false);
      let loading = $[0];
      let set_loading = $[1];
      let dispatch = $store.use_effect_dispatch();
      let resend_invite = (_) => {
        set_loading(true);
        let client_id = $auth.client_id();
        let _pipe = $invitation.resend(invitation, invitation.org_id, client_id);
        let _pipe$1 = $list.wrap(_pipe);
        let _pipe$2 = $user_effects.invite(_pipe$1);
        dispatch(_pipe$2);
        return undefined;
      };
      let delete_invite = (_) => {
        set_loading(true);
        dispatch($user_effects.uninvite(invitation));
        return undefined;
      };
      $redraw.use_effect(() => { return set_loading(false); }, [invitation]);
      let on_resend = $e.on_click(resend_invite);
      let on_delete = $e.on_click(delete_invite);
      return $l.row(
        toList([
          $l.gap(8),
          $l.wrap("wrap"),
          $l.styles(toList([$css.white_space("nowrap")])),
        ]),
        toList([]),
        toList([
          $button.primary(
            toList([$a.disabled(loading), $button.attributes.small(), on_resend]),
            toList([$h.text("Resend Invite")]),
          ),
          $button.secondary(
            toList([$a.disabled(loading), $button.attributes.small(), on_delete]),
            toList([$h.text("Delete Invite")]),
          ),
        ]),
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    actions(),
    (actions) => {
      return $redraw.compose(
        user_roles(),
        (user_roles) => {
          return $redraw.compose(
            $common.copy_id(),
            (copy_id) => {
              return $redraw.component_(
                "Authentication(InviteUsers",
                (_) => {
                  let store = $store.use_state();
                  let dispatch = $store.use_effect_dispatch();
                  use_organization_invitations(store, dispatch);
                  return $table.table(
                    toList([]),
                    toList([
                      $table.headers(
                        toList([
                          (() => {
                            let _pipe = $table.header("Invitee");
                            return $table.fit(_pipe);
                          })(),
                          (() => {
                            let _pipe = $table.header("URL");
                            return $table.clamp(_pipe, "250px", 300);
                          })(),
                          (() => {
                            let _pipe = $table.header("Created at");
                            return $table.fit(_pipe);
                          })(),
                          (() => {
                            let _pipe = $table.header("Expires at");
                            return $table.fit(_pipe);
                          })(),
                          (() => {
                            let _pipe = $table.header("Connection");
                            return $table.fit(_pipe);
                          })(),
                          $table.header("Roles"),
                          (() => {
                            let _pipe = $table.header("");
                            return $table.fit(_pipe);
                          })(),
                        ]),
                      ),
                      (() => {
                        let $ = invitations_data(store);
                        if ($ instanceof $remote.NotLoaded) {
                          return loading_table();
                        } else if ($ instanceof $remote.Loading) {
                          return loading_table();
                        } else if ($ instanceof $remote.Errored) {
                          return $table.body(toList([]));
                        } else {
                          let invitations = $[0][0];
                          let roles = $[0][1];
                          let connections = $[0][2];
                          return $table.body(
                            $list.map(
                              invitations,
                              (invitation) => {
                                let expired = $invitation.is_expired(invitation);
                                return $table.row(
                                  toList([
                                    $table.cell(
                                      $h.text(invitation.invitee_email),
                                    ),
                                    $table.cell(
                                      copy_id([invitation.invitation_url]),
                                    ),
                                    $table.cell(
                                      date(
                                        invitation.created_at,
                                        false,
                                        expired,
                                      ),
                                    ),
                                    $table.cell(
                                      date(invitation.expires_at, true, expired),
                                    ),
                                    $table.cell(
                                      user_connection(invitation, connections),
                                    ),
                                    $table.cell(
                                      user_roles(
                                        new UserRolesProps(invitation, roles),
                                      ),
                                    ),
                                    $table.cell(actions([invitation])),
                                  ]),
                                );
                              },
                            ),
                          );
                        }
                      })(),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function decode_content(roles, content) {
  let _pipe = $decode.run(
    content,
    $decrypt.filter_list(
      $decode.field(
        0,
        $decode.string,
        (email) => {
          return $decode.field(
            1,
            $decode.string,
            (user_roles) => {
              let user_roles$1 = $string.split(user_roles, ",");
              let user_roles$2 = $list.filter_map(
                user_roles$1,
                (r) => {
                  return $list.find(roles, (r_) => { return r_.name === r; });
                },
              );
              let $ = $list.is_empty(user_roles$2);
              if ($) {
                return $decode.success(new Error(undefined));
              } else {
                return $decode.success(new Ok([email, user_roles$2]));
              }
            },
          );
        },
      ),
    ),
  );
  return $result_.nil_error(_pipe);
}

function render_csv_users() {
  return $redraw.compose(
    $common.roles(),
    (roles_view) => {
      return $redraw.component_(
        "RenderCSVUsers",
        (props) => {
          let on_close = $e.on_click(
            (_) => { return props.on_end(new Error(undefined)); },
          );
          let on_accept = $e.on_click(
            (_) => {
              let users = props.users;
              let connection_id = props.connection_id;
              let response = new OnConfirm(connection_id, users);
              return props.on_end(new Ok(response));
            },
          );
          return $bool.lazy_guard(
            $list.is_empty(props.users),
            $h.none,
            () => {
              let disabled = props.connection_id === "";
              return $redraw.fragment(
                toList([
                  $table.table(
                    toList([]),
                    toList([
                      $table.headers(
                        toList([$table.header("Email"), $table.header("Roles")]),
                      ),
                      $table.body(
                        $list.map(
                          props.users,
                          (_use0) => {
                            let email = _use0[0];
                            let roles = _use0[1];
                            let names = $list.map(
                              roles,
                              (r) => { return r.name; },
                            );
                            return $table.row(
                              toList([
                                $table.cell($h.text(email)),
                                $table.cell(roles_view([names])),
                              ]),
                            );
                          },
                        ),
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.justify("end")]),
                    toList([]),
                    toList([
                      $button.secondary(
                        toList([$a.type_("button"), on_close]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.primary(
                        toList([
                          $a.type_("button"),
                          on_accept,
                          $a.disabled(disabled),
                        ]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              );
            },
          );
        },
      );
    },
  );
}

function user_csv() {
  return $redraw.compose(
    render_csv_users(),
    (render_csv_users) => {
      return $redraw.component_(
        "UserCSV",
        (props) => {
          let roles = props.roles;
          let on_end = props.on_end;
          let connection_id = props.connection_id;
          let $ = $redraw.use_state(toList([]));
          let users = $[0];
          let set_users = $[1];
          return $l.column(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $l.column(
                toList([$l.tag("label")]),
                toList([]),
                toList([
                  $sh.div(
                    $button.classes.primary(),
                    toList([]),
                    toList([$h.text("Select CSV")]),
                  ),
                  $h.input(
                    toList([
                      $a.type_("file"),
                      $a.style(toList([["display", "none"]])),
                      $events.on_files_change(
                        (files) => {
                          return $function.tap(
                            undefined,
                            (_) => {
                              let $1 = $list.first(files);
                              if ($1 instanceof Ok) {
                                let file = $1[0];
                                return $promise.map(
                                  $file.text(file),
                                  (content) => {
                                    return $result.try$(
                                      parse(content),
                                      (content) => {
                                        return $result.try$(
                                          decode_content(props.roles, content),
                                          (content) => {
                                            return new Ok(set_users(content));
                                          },
                                        );
                                      },
                                    );
                                  },
                                );
                              } else {
                                return $promise.resolve(new Error(undefined));
                              }
                            },
                          );
                        },
                      ),
                    ]),
                  ),
                ]),
              ),
              render_csv_users(
                new RenderCSVUsersProps(roles, on_end, users, connection_id),
              ),
            ]),
          );
        },
      );
    },
  );
}

function on_user_selected(data, set_roles) {
  return set_roles(
    (roles) => {
      let $ = $set.contains(roles, data);
      if ($) {
        return $set.delete$(roles, data);
      } else {
        return $set.insert(roles, data);
      }
    },
  );
}

function on_user_submit_email(props, chosen_roles, email, connection_id) {
  return $e.on_click(
    (_) => {
      let _block;
      {
        let chosen_roles$1 = $set.to_list(chosen_roles);
        _block = $list.filter_map(
          chosen_roles$1,
          (r) => {
            return $list.find(props.roles, (role) => { return role.id === r; });
          },
        );
      }
      let chosen_roles$1 = _block;
      return props.on_end(
        new Ok(new OnConfirm(connection_id, toList([[email, chosen_roles$1]]))),
      );
    },
  );
}

function user_selector() {
  return $redraw.component_(
    "UserSelector",
    (props) => {
      let $ = $redraw.use_state("");
      let email = $[0];
      let set_email = $[1];
      let $1 = $redraw.use_state_($set.new$());
      let chosen_roles = $1[0];
      let set_roles = $1[1];
      let submit_disabled = ($set.is_empty(chosen_roles) || $string.is_empty(
        email,
      )) || (props.connection_id === "");
      let on_close = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_submit = on_user_submit_email(
        props,
        chosen_roles,
        email,
        props.connection_id,
      );
      return $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $l.column(
            toList([
              $l.styles(
                toList([
                  $css.compose($text.sm($text.regular)),
                  $css.color($colors.palette.grey_800),
                ]),
              ),
            ]),
            toList([]),
            toList([
              $typo.text($typo.lg, $text.medium, "Enter a user"),
              $h.text(
                "Invite a user with its email and its roles. Roles and email ",
              ),
              $h.text("can't be empty."),
            ]),
          ),
          $input.input(
            (() => {
              let _pipe = $input.value(email);
              let _pipe$1 = $input.on_input(_pipe, set_email);
              return $input.placeholder(_pipe$1, "user@steerlab.ai");
            })(),
          ),
          $l.column(
            toList([$l.gap(6), $l.align("start")]),
            toList([]),
            toList([
              $l.row(
                toList([$l.gap(4), $l.wrap("wrap")]),
                toList([]),
                $list.map(
                  props.roles,
                  (role) => {
                    let on_click = (_) => {
                      return on_user_selected(role.id, set_roles);
                    };
                    let name = $h.text(role.name);
                    let size = $button.attributes.small();
                    let $2 = $set.contains(chosen_roles, role.id);
                    if ($2) {
                      return $button.primary(
                        toList([$e.on_click(on_click), size]),
                        toList([name]),
                      );
                    } else {
                      return $button.secondary(
                        toList([$e.on_click(on_click), size]),
                        toList([name]),
                      );
                    }
                  },
                ),
              ),
            ]),
          ),
          $l.row(
            toList([$l.gap(4), $l.justify("end")]),
            toList([]),
            toList([
              $button.secondary(toList([on_close]), toList([$h.text("Cancel")])),
              $button.primary(
                toList([$a.disabled(submit_disabled), on_submit]),
                toList([$h.text("Submit")]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

export function invite_modal() {
  return $redraw.compose(
    user_selector(),
    (user_selector) => {
      return $redraw.compose(
        user_csv(),
        (user_csv) => {
          return $redraw.component_(
            "InviteUsers",
            (props) => {
              let $ = $redraw.use_state("");
              let connection_id = $[0];
              let set_connection_id = $[1];
              let store = $store.use_state();
              return $when.some(
                $store.current_organization(store),
                (organization) => {
                  return $when.ok(
                    $remote.read(store.roles),
                    (roles) => {
                      let roles$1 = $list.sort(
                        roles,
                        (r1, r2) => {
                          return $common.compare_roles(r1.name, r2.name);
                        },
                      );
                      return $when.ok(
                        $remote.read(store.connections),
                        (connections) => {
                          return $when.ok(
                            (() => {
                              let conns = $store.organization_enabled_connections(
                                store,
                              );
                              return $result.map(
                                $remote.read(conns),
                                (conns) => {
                                  return $list.filter_map(
                                    conns,
                                    (connection) => {
                                      return $list.find(
                                        connections,
                                        (conn) => {
                                          return conn.id === connection.connection_id;
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            })(),
                            (connections) => {
                              let user_props = new UserSelectorProps(
                                roles$1,
                                props.on_end,
                                connection_id,
                              );
                              return $modal.modal(
                                toList([]),
                                toList([
                                  $modal.body(
                                    toList([$modal.large()]),
                                    toList([
                                      $modal.title(
                                        toList([]),
                                        toList([$h.text("Invite new users")]),
                                      ),
                                      $modal.explanations(
                                        toList([]),
                                        toList([
                                          $h.text(
                                            "You're about to add new collaborator(s) to ",
                                          ),
                                          $typo.text(
                                            $typo.md,
                                            $typo.medium,
                                            organization.display_name,
                                          ),
                                          $h.text(
                                            ". You can whether add one collaborator, or a batch of ",
                                          ),
                                          $h.text(
                                            "many users at once, using a CSV. Keep in mind the CSV ",
                                          ),
                                          $h.text(
                                            "file should be formatted as ",
                                          ),
                                          $common.raw("email;roles"),
                                          $h.text(" with "),
                                          $common.raw("roles"),
                                          $h.text(" separated with commas."),
                                        ]),
                                      ),
                                      $l.column(
                                        toList([$l.gap(4)]),
                                        toList([]),
                                        toList([
                                          $typo.text(
                                            $typo.md,
                                            $typo.medium,
                                            "Choose a connection",
                                          ),
                                          $l.row(
                                            toList([$l.gap(4), $l.wrap("wrap")]),
                                            toList([]),
                                            $list.map(
                                              connections,
                                              (connection) => {
                                                let on_click = (_) => {
                                                  return set_connection_id(
                                                    connection.id,
                                                  );
                                                };
                                                let name = $h.text(
                                                  connection.name,
                                                );
                                                let size = $button.attributes.small();
                                                let $1 = connection_id === connection.id;
                                                if ($1) {
                                                  return $button.primary(
                                                    toList([
                                                      size,
                                                      $e.on_click(on_click),
                                                    ]),
                                                    toList([name]),
                                                  );
                                                } else {
                                                  return $button.secondary(
                                                    toList([
                                                      size,
                                                      $e.on_click(on_click),
                                                    ]),
                                                    toList([name]),
                                                  );
                                                }
                                              },
                                            ),
                                          ),
                                        ]),
                                      ),
                                      user_selector(user_props),
                                      $l.row(
                                        toList([$l.align("center"), $l.gap(12)]),
                                        toList([]),
                                        toList([
                                          $common.separator(),
                                          $typo.text(
                                            $typo.sm,
                                            $typo.medium,
                                            "OR",
                                          ),
                                          $common.separator(),
                                        ]),
                                      ),
                                      user_csv(user_props),
                                    ]),
                                  ),
                                ]),
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
